// Countries listed first in the phone country dropdown (our markets, then the neighbours).
const phoneCountryOrder = ['pl', 'gb', 'cz', 'sk', 'hu', 'ro', 'bg', 'hr', 'gr', 'de', 'at', 'ua'];

// The .com store serves customers worldwide, so there the country is guessed from IP instead.
const isInternationalStore = () => window.config?.language?.region === 'US';

const getPhoneDefaultCountry = () =>
    window.config?.language?.region?.toLowerCase() || phoneCountryOrder[0];

export { phoneCountryOrder, isInternationalStore, getPhoneDefaultCountry };
